// frontend/src/lib/api.js
import { BASE } from "../api/client";

/* ---------------------------------------------------------
   TOKEN HELPERS
--------------------------------------------------------- */

export function getAccessToken() {
  return (
    localStorage.getItem("access") ||
    localStorage.getItem("accessToken") ||
    ""
  );
}

export function getRefreshToken() {
  return (
    localStorage.getItem("refresh") ||
    localStorage.getItem("refreshToken") ||
    ""
  );
}

export function clearSession() {
  localStorage.removeItem("access");
  localStorage.removeItem("refresh");
  localStorage.removeItem("accessToken");
  localStorage.removeItem("refreshToken");
  localStorage.removeItem("isLoggedIn");
}

/* ---------------------------------------------------------
   USER PROFILE (/api/auth/me/)
--------------------------------------------------------- */

export async function me() {
  const access = getAccessToken();
  if (!access) throw new Error("no_token");

  const res = await fetch(`${BASE}/api/auth/me/`, {
    headers: { Authorization: `Bearer ${access}` },
  });

  if (!res.ok) throw new Error("unauthorized");
  return res.json();
}

/* ---------------------------------------------------------
   REFRESH TOKEN (/api/auth/token/refresh/)
--------------------------------------------------------- */

export async function refresh() {
  const refreshTok = getRefreshToken();

  if (!refreshTok) throw new Error("no_refresh");

  const res = await fetch(`${BASE}/api/auth/token/refresh/`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ refresh: refreshTok }),
  });

  if (!res.ok) throw new Error("refresh_failed");

  const data = await res.json();

  if (data.access) {
    localStorage.setItem("access", data.access);
    localStorage.setItem("accessToken", data.access);
  }

  if (data.refresh) {
    localStorage.setItem("refresh", data.refresh);
    localStorage.setItem("refreshToken", data.refresh);
  }

  return data;
}

/* ---------------------------------------------------------
   REGISTER USER  (ADMIN ONLY)
--------------------------------------------------------- */

export async function registerEmail({ email, password, username }) {
  const access = getAccessToken();

  const res = await fetch(`${BASE}/api/auth/register/`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
    body: JSON.stringify({
      email,
      password,
      username: username || null,
    }),
  });

  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.detail || "failed_register");
  }

  return res.json();
}

/* ---------------------------------------------------------
   LOGOUT USER (/api/auth/logout)
--------------------------------------------------------- */

export async function logout() {
  const access = getAccessToken();
  const refreshTok = getRefreshToken();

  if (access && refreshTok) {
    await fetch(`${BASE}/api/auth/logout/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access}`,
      },
      body: JSON.stringify({ refresh: refreshTok }),
    }).catch(() => {});
  }

  clearSession();
}